import { PrintTimesheetSalarySettings } from "../types/salary";

export const DEFAULT_PRINT_TIMESHEET_SALARY_SETTINGS: PrintTimesheetSalarySettings = {
	title: 'BẢNG CHẤM CÔNG LƯƠNG',
	company_name: 'NOI THAT XBOX',
	company_address: '103 Đường số 4, Phường Tam Phú, TP. Thủ Đức, TP.HCM',
	template_html: `<div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4; color: #111827;">
	<div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px;">
		<div>
			<div style="font-size: 18px; font-weight: 700;">{{company_name_upper}}</div>
			<div>{{company_address}}</div>
		</div>
		<div style="text-align: right;">
			<div style="font-size: 16px; font-weight: 700;">{{title}}</div>
			<div>Ky luong: {{salary_month}}/{{salary_year}}</div>
			<div>Trạng thái: {{status}}</div>
		</div>
	</div>

	<table style="width: 100%; border-collapse: collapse; margin-bottom: 14px;">
		<tr><td style="border: 1px solid #d1d5db; padding: 6px; width: 30%;"><b>Nhân viên</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{employee_name}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Mã nhân viên</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{employee_code}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Tổng ngày công</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{total_working_days}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Ngày công thực tế</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{working_days}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Tổng lương</b></td><td style="border: 1px solid #d1d5db; padding: 6px;">{{total_salary}}</td></tr>
		<tr><td style="border: 1px solid #d1d5db; padding: 6px;"><b>Lương thực nhận</b></td><td style="border: 1px solid #d1d5db; padding: 6px; font-weight: 700;">{{net_salary}}</td></tr>
	</table>

	<div style="margin-top: 18px; text-align: right;">{{footer_city}}, ngày {{current_day}} tháng {{current_month}} năm {{current_year}}</div>
</div>`,
	footer_city_label: 'HCM',
}
